import React, { useState, useEffect } from 'react';
import img1 from "../../assets/images/main/main_visual_01.jpg";
import img2 from "../../assets/images/main/main_visual_02.jpg";
import img3 from "../../assets/images/main/main_visual_03.jpg";
import img4 from "../../assets/images/main/main_visual_04.png";
import styled from 'styled-components';

const CarouselContainer = styled.div`
    position: relative;
    width: 100%;
    height: 500px;
    overflow: hidden;
`;

const CarouselInner = styled.div`
    display: flex;
    transition: transform 0.5s ease;
    height: 100%;
    width: 100%;
    transform: translateX(-${props => props.activeIndex * 100}%);
`;

const CarouselSlide = styled.div`
    flex: 0 0 100%;
    height: 100%;
    background-image: url(${props => props.image});
    background-size: cover;
    background-position: center;
`;

const CarouselDot = styled.button`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: none;
    background-color: ${props => props.active ? '#fff' : 'rgba(255, 255, 255, 0.5)'};
    cursor: pointer;
`;

const DotContainer = styled.div`
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 10px;
`;

const MainCarousel = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    
    // 이미지 경로는 실제 프로젝트에 맞게 조정해야 합니다
    const images = [
        img1, img2, img3, img4,
    ];

    useEffect(() => {
        const interval = setInterval(() => {
        setActiveIndex((current) => 
            current === images.length - 1 ? 0 : current + 1
        );
        }, 5000);
        
        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <CarouselContainer>
        <CarouselInner activeIndex={activeIndex}>
            {images.map((image, index) => (
            <CarouselSlide key={index} image={image} />
            ))}
        </CarouselInner>
        <DotContainer>
            {images.map((_, index) => (
            <CarouselDot 
                key={index} 
                active={activeIndex === index} 
                onClick={() => setActiveIndex(index)} 
            />
            ))}
        </DotContainer>
        </CarouselContainer>
    );
};

export default MainCarousel;